import { MessageDescriptor } from '@lingui/core';
import { MacroMessageDescriptor } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useEffect } from 'react';
import { useMatches } from 'react-router';

export type MetaResolver = (args: {
  trans: {
    (descriptor: MacroMessageDescriptor): string;
    (literals: TemplateStringsArray, ...placeholders: any[]): string;
  };
}) => {
  title?: string;
  meta?: { name?: string; content: string }[];
};

export function HeadManager() {
  const matches = useMatches();
  const { i18n } = useLingui();

  useEffect(() => {
    let title: string | undefined;
    const metas: { name?: string; content: string }[] = [];

    for (const match of matches) {
      const resolver =
        match.handle && typeof match.handle === 'object' ? ('meta' in match.handle ? match.handle.meta : undefined) : undefined;
      if (typeof resolver !== 'function') continue;

      const resolved = resolver();

      if (resolved.title) {
        title = i18n._(resolved.title as MessageDescriptor);
      }

      if (resolved.meta) {
        for (const m of resolved.meta) {
          metas.push({
            name: m.name,
            content: i18n._(m.content),
          });
        }
      }
    }

    if (title) document.title = title;

    document.querySelectorAll('meta[data-managed]').forEach((el) => {
      el.remove();
    });

    for (const m of metas) {
      const el = document.createElement('meta');
      if (m.name) el.setAttribute('name', m.name);
      el.setAttribute('content', m.content);
      el.setAttribute('data-managed', 'true');
      document.head.appendChild(el);
    }
    // eslint-disable-next-line @typescript-eslint/unbound-method
  }, [matches, i18n._]);

  return null;
}
